module.exports = __WEBPACK_EXTERNAL_MODULE_86__;


//////////////////
// WEBPACK FOOTER
// external {"root":["Rx"],"commonjs":"rxjs/observable/fromEvent","commonjs2":"rxjs/observable/fromEvent","amd":"rxjs/observable/fromEvent"}
// module id = 86
// module chunks = 0